import { gql } from "graphql-tag";

export const SEND_MESSAGE = gql`
  mutation SendMessagesProfile(
    $interestListIds: [ID!]!
    $interestIds: [ID!]
    $elasticQuery: ElasticQuery
    $emailEnabled: Boolean!
    $emailBody: String!
    $emailSubject: String!
    $emailBccAddress: String
    $emailRespondToEnabled: Boolean
    $letterEnabled: Boolean!
    $letterBody: String!
    $smsEnabled: Boolean!
    $smsBody: String!
    $smsPropertyUseCaseId: ID
  ) {
    sendMessages(
      interestListIds: $interestListIds
      interestIds: $interestIds
      elasticQuery: $elasticQuery
      emailEnabled: $emailEnabled
      emailBody: $emailBody
      emailSubject: $emailSubject
      emailBccAddress: $emailBccAddress
      emailRespondToEnabled: $emailRespondToEnabled
      letterEnabled: $letterEnabled
      letterBody: $letterBody
      smsEnabled: $smsEnabled
      smsBody: $smsBody
      smsPropertyUseCaseId: $smsPropertyUseCaseId
    )
  }
`;

export const CREATE_ACTIVITY = gql`
  mutation createActivityContainer($data: ActivityInput!) {
    createActivity(data: $data) {
      id
      note
    }
  }
`;

export const LOG_CALL = gql`
  mutation logCall($interestId: ID!, $note: String, $outcome: String!, $reason: String) {
    logCall(interestId: $interestId, note: $note, outcome: $outcome, reason: $reason) {
      id
      note
    }
  }
`;
